// extracted by mini-css-extract-plugin
export default {"actions":"BiomarkersNotFound_actions__jFQIr"};